import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Upload } from '@grandvisionhq/api-client';
import { useApiConfig, uninitState, statusSuccess, loadingState, successState, failedState } from '@grandvisionhq/state';

const UploadContext = /*#__PURE__*/ React.createContext({});
const useUpload = ()=>React.useContext(UploadContext)
;
const UploadProvider = ({ scopes , shouldFetchConfigs =true , timeout =20000 , children ,  })=>{
    const timersRef = React.useRef({});
    const mountRef = React.useRef(true);
    const { apiUrl  } = useApiConfig();
    const [state, dispatch] = React.useReducer((s, action)=>{
        if (action.name === 'error') {
            return swcHelpers.objectSpread({}, s, {
                error: action.value
            });
        }
        // updating upload config
        return swcHelpers.objectSpread({}, s, {
            configs: swcHelpers.objectSpread({}, s.configs, {
                [action.name]: action.value
            })
        });
    }, {
        scopes,
        error: null,
        configs: scopes.reduce((m, scope)=>swcHelpers.objectSpread({}, m, {
                [scope]: uninitState()
            })
        , {})
    });
    function setError(error) {
        dispatch({
            name: 'error',
            value: error
        });
    }
    function updateConfig(scope, result) {
        // do not update component state if it has been unmounted
        if (!mountRef.current) {
            return;
        }
        dispatch({
            name: scope,
            value: result
        });
    }
    React.useEffect(()=>{
        // if the upload radio option does not exist => do not fetch configs
        if (!shouldFetchConfigs) {
            return;
        }
        mountRef.current = true;
        // use one signal to rule them all
        const abortController = new AbortController();
        const signal = abortController.signal;
        for (const scope of scopes){
            /**
       * If we already have successfully fetched the config for
       * this scope, there's no need to fetch it again.
       */ const scopeState = state[scope];
            if (scopeState && statusSuccess(scopeState)) {
                continue;
            }
            updateConfig(scope, loadingState());
            // setting the timer per scope
            timersRef.current[scope] = window.setTimeout(()=>{
                abortController.abort();
            }, timeout);
            // calling API for upload config
            Upload.getConfig(apiUrl, {
                scope
            }, {
                signal
            }).then((response)=>{
                clearTimeout(timersRef.current[scope]);
                updateConfig(scope, successState(response));
            }).catch((error)=>{
                clearTimeout(timersRef.current[scope]);
                updateConfig(scope, failedState(error));
            });
        }
        return ()=>{
            // Cancel the running requests when this component is unmounted.
            abortController.abort();
            mountRef.current = false;
        };
    }, [
        scopes,
        shouldFetchConfigs
    ]);
    return /*#__PURE__*/ React.createElement(UploadContext.Provider, {
        value: swcHelpers.objectSpread({}, state, {
            setError
        })
    }, children);
};

export { UploadContext, UploadProvider, useUpload };
//# sourceMappingURL=UploadProvider.js.map
